import { call, put, select, takeLatest } from 'redux-saga/effects'
import { BillingConstants } from '../../billing/store/billing.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { setCmsInformation } from '../store/cmsInformation.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getPcrIdSelector } from '../../home/selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* getCmsInformation(pcrDoc: IPcr) {
  const cmsInformation = pcrDoc.billing?.cmsInformation
  if (cmsInformation && Object.keys(cmsInformation).length !== 0) {
    yield put(setCmsInformation(cmsInformation))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(getCmsInformation, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in getCmsInformation.saga.ts: ${e}`))
  }
}

export function* getCmsInformationSaga() {
  yield takeLatest([BillingConstants.REFRESH_BILLING_DATA], performWithMutexHOG, preloadPCR)
}
